export default __webpack_public_path__ + "static/img_growing_together_2@2x-a6cd04421405fce2c2d5cf48f03bb0db.png";